import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';

const noop = () => { };

/**
 * @param {{
 *  className?: string;
 *  isDisabled: boolean;
 *  isLoading: boolean;
 *  onReset?: () => void;
 *  onSave?: () => void;
 * }} param0
 */
const ActionBar = ({
    isDisabled,
    isLoading,
    onReset,
    onSave,
    className,
}) => {
    const { t } = useTranslation('common', { keyPrefix: 'actions' });

    return (
        <div className={className || ''}>
            <Button
                className="apply-button"
                onClick={onSave || noop}
                color="primary"
                variant="contained"
                type="submit"
                disabled={isDisabled || isLoading}
            >
                {t('save')}
            </Button>
            <Button
                color="secondary"
                variant="contained"
                onClick={onReset || noop}
                disabled={isDisabled}
            >
                {t('discard')}
            </Button>
        </div>
    );
};

export default ActionBar;
